module.exports = __webpack_public_path__ + "static/ogp-noty-ecfb8a7b0f07a6436c8e3eb9336f5e12.png";